import { render, staticRenderFns } from "./userAvatarCard.vue?vue&type=template&id=db4eec80"
import script from "./userAvatarCard.vue?vue&type=script&lang=js"
export * from "./userAvatarCard.vue?vue&type=script&lang=js"
import style0 from "./userAvatarCard.vue?vue&type=style&index=0&id=db4eec80&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports